import {createTheme} from "@mui/material";

const green = '#087E38';
const lightGreen = '#4DA42F';

const grey = '#F3F5FB';
const lightGrey = '#454D66';
const bluishGray = '#7E869C';
const disabledGray = '#949494';

const darkBlue = '#2A2E3C';
const lightBlue = '#17A1FA';
const veryLightBlue = '#DCECF5';
const selectedOrderBlue = '#D8F0FF';
const parcelTableBlue = '#E4F5FF';
const blue = '#157DBA';

const mediumGrey = '#D1D4E0';
const darkGrey = '#E1E3EA';

const yellow = '#DAD873';
const lightYellow = '#F8F7E3';

const red = '#D42D4A';

const background = '#F1F1FB';
const darkBackground = '#2A2E3C';
const lightBackground = '#F1F1FB';

export const getTheme = () => createTheme({
    palette: {
        primary: {
            main: green,
            light: lightBackground,
            dark: darkBackground,
        },
        text: {
            primary: darkBlue,
            disabled: disabledGray
        },
    },
    barekam: {
        background: background,
        lightBackground: lightBackground,
        darkBackground: darkBackground,
        green: green,
        lightGreen: lightGreen,
        grey: grey,
        mediumGrey: mediumGrey,
        darkGrey: darkGrey,
        yellow: yellow,

        text: {
            regular: lightGrey,
            dark: darkBackground,
        },

        sidebar: {
            background: '#FFF',

            textDark: darkBackground,
            textLight: '#FFF',
            textCount: '#A9A9C2',

            tabButton: {
                selected: green,
                hover: grey,
                hoverSelected: lightGreen,
            },

            filterButton: {
                selected: green,
                timeChip: '#da1944',
                hover: grey,
                hoverSelected: green,
            },

            dashboardButton: {
                background: yellow,
                hover: yellow,
            }
        },

        actionbar: {
            buttons: {
                toExisting: {
                    backgroundColor: lightBlue
                },
                newOrder: {
                    backgroundColor: green
                }
            }
        },

        header: {
            background: '#FFF',

            textDark: darkBackground,
            textLight: '#FFF',

            button: {
                hoverBackground: grey,
                hoverText: '#da1944',
            },

            myAddressesButton: {
                background: darkBackground,
                hover: '#da1944',
            },

            logoutButton: {
                color: blue
            }
        },

        login: {
            input: {
                // selected: string,
                // hover: string,
                iconColor: lightBlue,
                borderColor: lightBlue,
            },

            actionButton: {
                color: '#FFF',
                backgroundColor: green,
                backgroundHoverColor: green,
            }
        },

        orderPopup: {
            successIcon: green,

            buttons: {
                add: {
                    color: lightGrey,
                    backgroundColor: yellow,
                    backgroundHoverColor: yellow,
                },
                select: {
                    menuItem: {
                        backgroundColorHover: veryLightBlue,
                        backgroundColorSelected: lightYellow,
                    },
                    newRecipient: {
                        color: '#FFF',
                        backgroundColor: green,
                        backgroundColorHover: green,
                    }
                }
            },
            parcelTable: {
                background: parcelTableBlue,
                successText: lightGreen,

                buttons: {
                    background: {
                        default: mediumGrey,
                        remove: red,
                        toAnotherOrder: lightBlue,
                        newOrder: green
                    },
                    text: {
                        default: darkBlue
                    }
                }
            },
            chips: {
                statusChip: {
                    color: lightBlue,
                    backgroundColor: veryLightBlue,
                }
            }
        },

        filter: {
            container: {
                borderColor: mediumGrey
            },
            buttons: {
                filterMain: {
                    backgroundColor: darkBlue,
                    backgroundHoverColor: darkBlue,
                },
                filterSecondary: {
                    backgroundColor: '#FFF',
                    backgroundHoverColor: grey,
                },
            },
            chips: {
                colors: {
                    yellow: '#F2B143',
                    blue: '#00B2FF',
                    red: '#DA1944',
                    green: '#087E38',
                    gray: '#2A2E3C',
                }
            }
        },

        recipient: {
            buttons: {
                cancel: {
                    color: darkBlue,
                    backgroundColor: mediumGrey,
                },
                add: {
                    color: '#FFF',
                    backgroundColor: green,
                },
                delete: {
                    color: '#FFF',
                    backgroundColor: red,
                }
            },
        },

        orderList: {
            text: lightGrey,
            border: grey,

            header: {
                background: grey,
                text: darkBackground
            },
            row: {
                selectedBackground: selectedOrderBlue,
                hoverBackground: grey
            },
            card: {
                selectedBackground: grey,
                hoverBackground: grey
            },
            summary: {
                paymentButton: {
                    backgroundColor: green,
                    backgroundColorDisabled: mediumGrey,
                }
            }
        },

        orderProgress: {
            background: '#D9D9D9',
            bar: '#FFA800',
        },

        calendar: {
            day: {
                color: bluishGray,
                selectedColor: blue,
                selectedBackground: lightBackground,
            },
            weekend: {
                color: blue,
                selected: '#FFF',
            },
            button: {
                color: lightGrey,
                selectedColor: '#FFF',
                backgroundColor: lightGreen,
            },
            otherDayColor: lightGrey,
            weekNumberBackground: lightGrey,
        },

        additionalService: {
            text: lightGrey,

            border: {
                default: mediumGrey,
                selected: green
            },
            button: {
                default: yellow,
                hover: lightBlue,
                selected: green,
                proceed: blue
            },
            background: {
                hover: grey
            },
        },

        monthlyLimits: {
            buttons: {
                remove: {
                    color: lightGrey,
                    backgroundColor: yellow,
                    backgroundHoverColor: yellow,
                },
                set: {
                    color: '#FFF',
                    backgroundColor: red,
                    backgroundHoverColor: red,
                }
            }
        },

        notifications: {
            items: {
                unSeen: {
                    background: darkGrey
                },
                seen: {
                    background: '#FFF'
                }
            }
        },

        documents: {
            order: {
                product: {
                    borderColor: mediumGrey,
                    backgroundColor: darkGrey,
                }
            },
        },

        dashboard: {
            barColors: ['hsl(198, 74%, 39%)', 'hsl(144, 88%, 26%)', 'hsl(59, 60%, 46%)', 'hsl(35, 68%, 53%)', 'hsl(22, 85%, 53%)', 'hsl(11, 72%, 49%)', 'hsl(346, 100%, 64%)', 'hsl(198, 100%, 50%)', 'hsl(53, 14%, 25%)', 'hsl(60, 92%, 71%)']
        },

        red: red, // Accent 2
        blue: blue, // Accent 3
        greenLight: '#82C06D',
        greyDark: darkBackground, // Headings
        greyish: lightGrey, // Paragraph
        lightGrey: lightGrey, // Table
    }
});
